import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LocalService,DATE_WITH_HOUR_FORMAT } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { SeguimientoDocumentosComponent } from './seguimiento-documentos/seguimiento-documentos.component';
import { SeguimientosService } from '../../../../../services/database/pqrsd/seguimientos.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetSeguimientos } from '../../../../../shared/interfaces/database/pqrsd';

@Component({
  selector: 'app-seguimiento-historial',
  standalone: true,
  imports: [CommonModule, TranslateModule, CustomTableComponent,
    TableModule, ButtonModule, SeguimientoDocumentosComponent],
  templateUrl: './seguimiento-historial.component.html',
  styleUrl: './seguimiento-historial.component.scss'
})
export class SeguimientoHistorialComponent implements OnInit {
  @Input() actividadId!: number;

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _ts: SeguimientosService, public readonly ls: LocalService, private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate()
    this.getSeguimientos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      seguimientos: this._t.get('common.seguimientos'),
      seguimiento: this._t.get('common.seguimiento'),
      fechaSeguimiento: this._t.get('common.fechaSeguimiento'),
      creadoPorUsuario: this._t.get('common.creadoPorUsuario')
    }));

    this.configureTable();
  }

  private configureTable() {
    this.customTable = {
      columns: [
        {
          field: 'expand',
          class:'p-button-info',
          header: '',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'comentario',
          header: this.trans.seguimiento,
          sort: false,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaSeguimiento',
          header: this.trans.fechaSeguimiento,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE
        },
        {
          field: 'creadoPorUsuario',
          header: this.trans.creadoPorUsuario,
          sort: false,
          dataType: DataColumnType.CHECK
        }
      ]
    } as ICustomTable;
  }

  getSeguimientos() {
    this._ts.getSeguimientos(this.actividadId).subscribe({
      next: (data: IGetSeguimientos[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
